import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { typographyCss } from "@/lib/typography";
import { THEME_KEYS } from "@/lib/theme";

const SiteCtx = createContext<any>({});

export function SiteProvider({ children }: { children: React.ReactNode }) {
  const [site, setSite] = useState<any>(null);
  const [collections, setCollections] = useState<any[]>([]);

  const load = () => api.get("/site").then((r) => setSite(r.data)).catch(() => setSite({}));
  useEffect(() => {
    load();
    api.get("/collections").then((r) => setCollections(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const t = site?.theme || {};
    const root = document.documentElement.style;
    THEME_KEYS.forEach(([k, v]) => (t[k] ? root.setProperty(v, t[k]) : root.removeProperty(v)));
    const fontUrl = site?.wordmark_font_url;
    let tag = document.getElementById("wordmark-font") as HTMLStyleElement | null;
    if (fontUrl) {
      if (!tag) { tag = document.createElement("style"); tag.id = "wordmark-font"; document.head.appendChild(tag); }
      tag.textContent = `@font-face{font-family:"ITC Blair";src:url("${encodeURI(fontUrl)}");font-display:swap;}`;
    } else if (tag) tag.remove();
    let ty = document.getElementById("site-typography") as HTMLStyleElement | null;
    if (!ty) { ty = document.createElement("style"); ty.id = "site-typography"; document.head.appendChild(ty); }
    ty.textContent = typographyCss(site?.typography);
  }, [site]);

  return <SiteCtx.Provider value={{ site, reload: load, collections }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
